var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { createStyles } from 'antd-style';
var useStyles = createStyles(function (_ref, _ref2) {
  var css = _ref.css,
    token = _ref.token,
    prefixCls = _ref.prefixCls;
  var size = _ref2.size,
    offsetX = _ref2.offsetX,
    offsetY = _ref2.offsetY;
  var dynamicVal = size === 'small' ? '5px' : size === 'medium' ? '9px' : size === 'default' ? '13px' : '17px';
  return {
    dropDownWrap: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        min-width: auto !important;\n        & .", "-dropdown-menu {\n          margin-left: ", "px;\n          margin-top: ", "px;\n          border-radius: 6px;\n          padding: 0;\n          overflow: hidden;\n          box-shadow: none;\n          border: 1px solid ", ";\n          .", "-dropdown-menu-item {\n            padding: ", " 12px;\n            border-radius: 0;\n            /* &:hover ~ li {\n              background: none;\n            } */\n          }\n        }\n      "])), prefixCls, offsetX, offsetY, token.colorPrimaryBorder, prefixCls, dynamicVal)
  };
});
export default useStyles;